import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import uuid from "react-uuid";
import ReportService from "../../service/Docente/ReportService";
import GenericUtils from "../../utils/GenericUtils";
import ReportStyles from "../../styles/pages/Summaries/ReportStyles";
import FolderIcon from "../../assets/icons/Summary_ActivityPlanIcon.svg";
import GearIcon from "../../assets/icons/Summary_AdminIcon.svg";
import ReportCard from "./ReportCard";
import PrintReportIcon from "../../assets/icons/PrintReportIcon.svg";
import ScheduleIcon from "../../assets/icons/Summary_ScheduleIcon.svg";
import ModalReportStyles from "../../styles/pages/Summaries/ModalReportStyles";
import TypeReportCard from "./TypeReportCard";
import ButtonStyles from "../../styles/components/ButtonStyles";
import {
    StyledHeader,
    StyledSubTitle,
    StyledTitle,
} from "../../styles/MainStyles";
import Autocomplete from "../../components/Autocomplete";
import { ReportType, ReportData } from "../../model/Report";

const { StyledIconModalButton } = ModalReportStyles;
const { BtnOutlinePrimary } = ButtonStyles;
const {
    StyledGridDiv,
    StyledContainerCards,
    StyledContainerPage,
    StyledContainerAutocomplete,
} = ReportStyles;

function Reports() {
    const { instance } = useMsal();
    const [reportType, setReportType] = useState<ReportType[]>([]);
    const [dataReport, setDataReport] = useState<ReportData[]>([]);
    const [reportList, setReportList] = useState<ReportData[]>([]);
    const [selected, setSelected] = useState<ReportData[]>([]);
    const [titleList, setTitleList] = useState<any[]>([]);
    const [showReport, setShowReport] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [selectedReportTitle, setSelectedReportTitle] = useState("");
    const [selectedType, setSelectedType] = useState("");

    const getTypeReportResponse = async (): Promise<void> => {
        const response = await ReportService.getTypeReport(instance);

        if (GenericUtils.isSuccessStatus(response)) {
            const responseData = response.data.itens;
            setReportType(responseData);
        }
    };

    const fetchUrlData = async (): Promise<void> => {
        const response = await ReportService.getReportData(instance);

        if (GenericUtils.isSuccessStatus(response)) {
            let responseData = response.data.itens;

            responseData = responseData.map((item: ReportData) => {
                if (
                    item.nome ===
                    "Relatório Gestão Hora Extra Reposição Antecipação Substituição"
                ) {
                    return {
                        ...item,
                        nome: "Relatório Gestão Hora Letiva RE Reposição Antecipação Substituição",
                    };
                }
                return item;
            });

            setDataReport(responseData);

            const listTitleReport = responseData.map((item: ReportData) => {
                return item.nome;
            });

            setTitleList(listTitleReport);

            const listOfTitle = listTitleReport.map((item: ReportData) => {
                const rawLabel =
                    typeof item === "string" ? item : item?.nome ?? "";

                let label = rawLabel;

                if (
                    label ===
                    "Relatório Gestão Hora Extra Reposição Antecipação Substituição"
                ) {
                    label =
                        "Relatório Gestão Hora Letiva RE Reposição Antecipação Substituição";
                }

                return {
                    value: rawLabel,
                    label: String(label), // Garante que será string
                };
            });

            const overtimeReports: string[] = [
                "Relatório Workflow Hora Extra",
                "Relatório Criação e Exclusão de Cartão Hora Extra",
            ];

            const filteredListOfTitles = listOfTitle.filter(
                (item: { label: string; value: string }) => {
                    const { label } = item;

                    // if (overtimeReports.includes(label)) {
                    //     return false;
                    // }

                    return item;
                }
            );

            setReportList(filteredListOfTitles);
        }
        getTypeReportResponse();
    };

    useEffect(() => {
        fetchUrlData();
    }, []);

    const handleTypeCardClick = (typeId: string) => {
        setSelectedType(typeId);
        setShowReport(true);
    };

    const folderInfo = "Plano de Atividades";
    const gearInfo = "Administrativos";

    const handleTypeIcon = (name: string) => {
        if (name === folderInfo) return FolderIcon;
        if (name === gearInfo) return GearIcon;

        return ScheduleIcon;
    };

    const typeReportList = (
        <StyledGridDiv>
            {reportType?.map((item: any) => (
                <StyledIconModalButton
                    key={item.id}
                    onClick={() => handleTypeCardClick(item.id)}
                >
                    <TypeReportCard
                        cardId={item.id}
                        icon={handleTypeIcon(item.nome)}
                        imgDescription="Ícone representando o tipo de relatório"
                        title={item.nome}
                        description={item.descricao}
                    />
                </StyledIconModalButton>
            ))}
        </StyledGridDiv>
    );

    const handleBackButtonClick = () => {
        setShowCard(false);
        setShowReport(false);
        setSelected([]);
        window.scrollTo(0, 0);
    };

    const backButton = (
        <div style={{ marginTop: "30px" }}>
            <BtnOutlinePrimary onClick={() => handleBackButtonClick()}>
                Voltar
            </BtnOutlinePrimary>
        </div>
    );

    const listReportCard = (
        <StyledContainerPage>
            <StyledContainerCards>
                {dataReport.map((item: ReportData) =>
                    item &&
                    item.tipos &&
                    item.tipos.length > 0 &&
                    item.tipos[0].id === selectedType ? (
                        <ReportCard
                            key={item.id}
                            cardId={item.id}
                            icon={handleTypeIcon(item.tipos[0].id)}
                            imgDescription="Imagem representando um ícone do tipo de relatório"
                            title={item.nome}
                            type={item.tipos[0].id}
                            data={item.parametros}
                            description={item.descricao || "Relatórios"}
                            buttonIcon={PrintReportIcon}
                            imgButtonDescription="Ícone representando um arquivo"
                        />
                    ) : null
                )}
            </StyledContainerCards>
            {showReport && backButton}
        </StyledContainerPage>
    );

    const renderReportCard = () => {
        const titleFound = titleList.find(
            (card) => card === selectedReportTitle
        );
        const data = dataReport.find((card) => card.nome === titleFound);

        if (data && data.tipos && data.descricao) {
            const cardType = data.tipos.length > 0 ? data.tipos[0].id : uuid();

            return (
                <div style={{ marginTop: 50 }}>
                    <ReportCard
                        icon={handleTypeIcon(cardType)}
                        cardId={data.id}
                        imgDescription="Imagem representando um ícone do tipo de relatório"
                        title={data.nome}
                        type={cardType}
                        data={data.parametros}
                        description={data.descricao}
                        buttonIcon={PrintReportIcon}
                        imgButtonDescription="Ícone representando um arquivo"
                    />
                    {showCard && backButton}
                </div>
            );
        }
        return null;
    };

    type Option = string | Record<string, any>;

    const handleAutocompleteChange = (selectedOptions: Option[]) => {
        const title = selectedOptions.map((i: any) => i.value);
        setShowCard(true);
        setShowReport(true);
        setSelected(title);
        setSelectedReportTitle(title.join(", "));
    };

    const autoComplete = (
        <StyledContainerAutocomplete>
            <Autocomplete
                onChange={handleAutocompleteChange}
                options={reportList}
                placeholder="Pesquise por relatório"
                selected={selected}
                style={{
                    border: "none",
                    width: "704px",
                }}
            />
        </StyledContainerAutocomplete>
    );

    const cards = showReport ? listReportCard : typeReportList;

    return (
        <ThemeProvider theme={{}}>
            <StyledHeader>
                <StyledTitle>Relatórios</StyledTitle>
                <StyledSubTitle>
                    Confira os documentos com as informações referentes a
                    atividades, grade horária, abonos e outros.
                </StyledSubTitle>
            </StyledHeader>
            {!showReport && autoComplete}
            {showCard ? renderReportCard() : cards}
        </ThemeProvider>
    );
}

export default Reports;
